import React, { useState } from "react";
import { Helmet } from "react-helmet";
import AdminProfileEdit from "../../layout/admin/AdminProfileEdit";
import Chatbox from "../../layout/common/Chatbox";
import Footer from "../../layout/common/Footer";
import Header from "../../layout/common/Header";
import NavHeader from "../../layout/common/NavHeader";
import SidebarTest from "../../layout/common/SidebarTest";

const AdminProfile = () => {
  const [showChtBox, setShowChtBox] = useState(false);
  const chtBoxHandler = (e) => {
    setShowChtBox(!e);
  };

  const chatboxClose = (e) => {
    setShowChtBox(!e);
  };
  return (
    <React.Fragment>
      <Helmet>
        <title>Admin Profile</title>
      </Helmet>
      <NavHeader />
      <Header onClick={chtBoxHandler} showChtBox={showChtBox} />
      <Chatbox showChtBox={showChtBox} chatboxClose={chatboxClose} />
      <SidebarTest />
      <AdminProfileEdit />
      <Footer />
    </React.Fragment>
  );
};

export default AdminProfile;
